import styled from "styled-components";
import { Swiper, SwiperSlide } from "swiper/react";

export const HeaderCarouselSwiper = styled(Swiper)``;

export const HeaderCarouselSwiperSlide = styled(SwiperSlide)``;
